<template>
  <!-- quiz -->
  <div class="quiz left-slider-right d-flex flex-column align-self-center">
    <div v-if="done" class="done">
      <h3><strong>{{ $t("quiz.done_message") }}</strong></h3>

      <!-- TODO: hide nextline when on mobile -->
      <p>{{ $t("quiz.correct") }}: {{ correct }}, {{ $t("quiz.incorrect") }}: {{ incorrect }}</p>

      <p>{{ $t("quiz.done_paragraph") }}</p>

      <div class="quiz-navigation d-flex flex-column">
        <button
          type="button"
          class="btn btn-outline-light align-self-start"
          @click="reset">
          {{ $t("quiz.again") }}
        </button>
      </div>
    </div>

    <div v-else class="left-slider-right d-flex flex-column align-items-start">
      <!-- Note: if and for should not both be used here. -->
      <QuizQuestion
        v-for="(item, index) in questions"
        v-if="questions_index === index"
        :key="index"

        :displayNumber="index + 1"
        v-bind="item"

        @answered="answered"
      />

      <div v-if="current_question.answered" class="quiz-navigation d-flex flex-column">
        <button
          type="button"
          class="btn btn-outline-light align-self-center"
          @click="next"
        >
          {{ $t("quiz.next") }}
        </button>
      </div>
    </div>

    <QuizProgress :index="questions_index" :total="6" />
  </div>
</template>

<script>
import QuizQuestion from '@/components/quiz/QuizQuestion.vue';
import QuizProgress from '@/components/quiz/QuizProgress.vue';
import shuffleArray from '@/utils/shuffleArray.js';
import questions from '@/data/questions.json';

// Quiz only has 6 questions
const questionCount = 6;

// Reset, shuffle and slice questions
function getNewQuestions() {
  return shuffleArray(questions.map((q) => {
    const aQ = q;

    // Default all questions to be unanswered
    aQ.answered = false;
    return aQ;
  })).slice(0, questionCount);
}

export default {
  components: { QuizQuestion, QuizProgress },
  data() {
    return {
      questions_index: 0,
      questions: getNewQuestions(),
      correct: 0,
      incorrect: 0,
    };
  },
  computed: {
    current_question() {
      return this.questions[this.questions_index];
    },
    done() {
      return this.questions_index >= this.questions.length;
    },
  },
  methods: {
    next() {
      this.questions_index += 1;
    },
    answered(correct) {
      this.current_question.answered = true;

      // Keep score
      if (correct) {
        this.correct += 1;
      } else {
        this.incorrect += 1;
      }
    },
    reset() {
      this.questions = getNewQuestions();
      this.questions_index = 0;
      this.correct = 0;
      this.incorrect = 0;
    },
  },
};
</script>

<style scoped lang="scss">
  .done {
    font-size: large;
    color: white;
  }

  .quiz {
    overflow: hidden;
    -webkit-overflow-scrolling: touch;
    padding-bottom: 72px; // height of progress footer
    position: relative;
    max-width: 600px;
    width: 100%;
    height: 100%;
    margin: 0 0 16px 0;
    @media (max-width: 992px) {
        padding-top: 0;
    }
    .done {
      margin: 36px 0 0 0;
      @media (max-width: 576px) {
      margin: 32px 0 0 0;
      }
      h3 {
        margin: 0 0 24px 0;
      }
      .btn-outline-light.focus, .btn-outline-light:focus {
        box-shadow: 0 0 0 0 rgba(248,249,250,0);
      }
    }
    .left-slider-right {
      margin: 36px 0 16px 0;
      @media (max-width: 575.98px) {
        margin: 32px 0 16px 0;
      }
      .quiz-navigation button {
        margin-top: 24px;
        outline: none !important;
        box-shadow: none;
        @media (max-width: 575.98px) {
          margin-top: 16px;
        }
      }

    }
  }

</style>



// WEBPACK FOOTER //
// src/views/quiz.vue